import { TButtonSize } from '@r1-frontend/ui-react/components/buttons/button';

const getPaddingBySize = (size: TButtonSize, hasIcon: boolean, isRounded: boolean): string => {
    switch (size) {
        case 'large':
        default:
            return isRounded ? '12px' : '12px 24px';
        case 'medium':
            return isRounded ? '8px' : '8px 24px';
        case 'small':
            return isRounded ? '6px' : `${hasIcon ? 6 : 8}px 16px`;
    }
};

export default getPaddingBySize;
